import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { captureAttribution } from "@/lib/attribution";
import logoNavbar from "@/assets/logo-navbar.webp";
import heroBg from "@/assets/hero-bg-hq-1200.webp";
import heroBg800 from "@/assets/hero-bg-hq-800.webp";
import heroBg480 from "@/assets/hero-bg-hq-480.webp";

// Preload the LCP element (navbar logo) as early as possible.
// This is injected synchronously before React renders so the browser
// can begin fetching the logo immediately, reducing LCP resource load delay.
if (typeof document !== "undefined") {
  const preloadLink = document.createElement("link");
  preloadLink.rel = "preload";
  preloadLink.as = "image";
  preloadLink.href = logoNavbar;
  preloadLink.type = "image/webp";
  // @ts-ignore - fetchPriority is a valid HTMLLinkElement property in modern browsers
  preloadLink.fetchPriority = "high";
  document.head.appendChild(preloadLink);

  // Preload the homepage hero background — the LCP element on "/".
  // Only preload on the homepage to avoid wasted bandwidth on other routes.
  if (window.location.pathname === "/") {
    const heroPreload = document.createElement("link");
    heroPreload.rel = "preload";
    heroPreload.as = "image";
    heroPreload.href = heroBg;
    heroPreload.setAttribute(
      "imagesrcset",
      `${heroBg480} 480w, ${heroBg800} 800w, ${heroBg} 1200w`,
    );
    heroPreload.setAttribute("imagesizes", "100vw");
    heroPreload.type = "image/webp";
    // @ts-ignore
    heroPreload.fetchPriority = "high";
    document.head.appendChild(heroPreload);
  }
}

// Record first-touch traffic attribution before anything else runs.
captureAttribution();

createRoot(document.getElementById("root")!).render(<App />);
